import React from 'react';
import { Box } from '@mui/material';
import SanityImage from 'gatsby-plugin-sanity-image';

interface BackgroundImageProps {
  imageData: any | null;
}

const BackgroundImage = ({ imageData }:BackgroundImageProps) => {
    
    if (!imageData || !imageData.asset) return null;
    
  return (
    <Box
      component={SanityImage}
      asset={imageData.asset}
      alt={'foo'}
      className="section-background-image-cover"
      loading={'eager'}      
      zIndex={-1}
      sx={{
        position: 'absolute',
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        // zIndex: -2,
        objectPosition:
          imageData?.hotspot &&
          `${(imageData.hotspot.x * 100).toFixed(2)}% ${(imageData.hotspot.y * 100).toFixed(2)}%`,
        //   ...sectionContainerProps
      }}
    />
  );
};

export default BackgroundImage;
